import axios from "axios";
import authStorage from "../utils/authStorage";

export default {
  getSessionToken() {
    return authStorage.getToken();
  },

  getSessionHeaders() {
    return authStorage.getAuthHeaders();
  },

  deleteSession() {
    authStorage.removeToken();
  },

  validateSession() {
    const url = process.env.VUE_APP_ROOT_API + "/customers/profile";
    return axios.get(url, this.getSessionHeaders());
  },

  login(loginCredentials) {
    const url = process.env.VUE_APP_ROOT_API + "/auth/login";
    return axios.post(url, loginCredentials);
  },

  logout() {
    this.deleteSession();
  }
};
